/**
 * Reactive Auth store for tracking current user and loading state using Svelte 5 Runes.
 */

import type { User } from 'firebase/auth';

export interface UserProfileData {
	displayName?: string;
	email?: string;
	handle?: string;
	photoURL?: string;
	defaultCurrency?: string;
	paymentLinks?: {
		paypal?: string;
		venmo?: string;
		bank?: string;
	};
	status?: 'active' | 'anonymized';
}

class AuthStore {
	user = $state<User | null>(null);
	profile = $state<UserProfileData | null>(null);
	loading = $state(true);

	setAuth(user: User | null, profile: UserProfileData | null = null) {
		this.user = user;
		this.profile = profile;
		this.loading = false;
	}

	setLoading(value: boolean) {
		this.loading = value;
	}
}

export const authStore = new AuthStore();
